import {
  useGetPersonalTokensQuery,
  GetPersonalTokensQuery,
} from '@sketch/gql-types'

export const useGetPersonalTokens = () => {
  const personTokensResult = useGetPersonalTokensQuery()
  const { data: personalTokensData, ...rest } = personTokensResult
  return { ...rest, ...normalizePersonalTokens(personalTokensData) }
}

function normalizePersonalTokens(
  personalTokensData: GetPersonalTokensQuery | undefined
) {
  if (!personalTokensData) return {}

  const { personalTokens } = personalTokensData.me

  return { personalTokens }
}
